export const UPDATE_AGENT_COORDINATES = "UPDATE_AGENT_COORDINATES";